/* GET QUIZZ ANSWER USER */
export const GET_QUIZZ_ANSWER_USER = "GET_QUIZZ_ANSWER_USER"
export const GET_QUIZZ_ANSWER_USER_SUCCESS = "GET_QUIZZ_ANSWER_USER_SUCCESS"
export const GET_QUIZZ_ANSWER_USER_CLEAN = "GET_QUIZZ_ANSWER_USER_CLEAN"
export const GET_QUIZZ_ANSWER_USER_ERROR = "GET_QUIZZ_ANSWER_USER_ERROR"
